// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgramCardIcon-module__rotated--K5yY6RHRJj{transform:rotate(15deg)}.ProgramCardIcon-module__small--f1NOjcVM1q{width:62px}`, "",{"version":3,"sources":["webpack://./../../packages/loyalty-program-ui/src/components/UI/ProgramCardIcon/ProgramCardIcon.module.css"],"names":[],"mappings":"AAAA,6CACE,uBACF,CAEA,2CACE,UACF","sourcesContent":[".rotated {\n  transform: rotate(15deg);\n}\n\n.small {\n  width: 62px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rotated": `ProgramCardIcon-module__rotated--K5yY6RHRJj`,
	"small": `ProgramCardIcon-module__small--f1NOjcVM1q`
};
export default ___CSS_LOADER_EXPORT___;
